import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SocialFacebookOutlineIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M10.8543 3.51692C11.5243 3.1931 12.39 3 13.4973 3H16.9649V6.93669H14.27C14.2631 6.93669 14.2391 6.93859 14.1988 6.95531C14.1588 6.97192 14.114 6.99872 14.0721 7.03411C14.03 7.06967 13.9998 7.10623 13.9823 7.1355C13.9743 7.1488 13.9708 7.15751 13.9693 7.16161V8.63931H17L16.9598 9.14511C16.8712 10.2615 16.7128 11.3671 16.5138 12.4686H13.9541V21H8.91353V12.4686H7V8.65124H8.91353V6.77678C8.91353 6.76755 8.91347 6.75691 8.9134 6.74492C8.9119 6.48421 8.90675 5.5881 9.44849 4.73744C9.73758 4.28348 10.182 3.84184 10.8543 3.51692ZM15.5591 11.5212C15.6266 11.0972 15.7313 10.3814 15.8099 9.58667H12.8621V7.15194C12.8621 6.83011 13.0763 6.54383 13.2946 6.35958C13.5204 6.16912 13.8657 5.98933 14.27 5.98933H15.8577V3.94737H13.4973C12.5412 3.94737 11.8713 4.11344 11.3988 4.3418C10.9285 4.56907 10.6233 4.87263 10.4207 5.19073C10.0184 5.82245 10.0201 6.50796 10.0207 6.75224C10.0207 6.761 10.0207 6.76918 10.0207 6.77678V9.59861H8.10721V11.5212H10.0207V20.0526H12.8469V11.5212H15.5591Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
